import React, {Component} from 'react';
import Table from "../../components/Table/Table";
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {Col} from "reactstrap";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import './ProggressPayment.css'

class BayiList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            manual: false,
            content: [],
            total: 0,
            loading: false,
            searching: false,
            searchQuery: undefined,
            page: 0,
            size: 10,
            distributors: [],
            distributorMap:[],
            parentCustomerId:-1,
            hakedisModal:false,
            sendMultipleInvoiceModal:false,
            updateModal:false,
            selectedCity: null,
            cities:[],
            workType: [ {value: null, label: "Tümü"},
                        {value: 1, label: "Müşteri Kendi Öder"},
                        {value: 2, label: "Bayi Müşteri Adına Öder"},
                        {value: 3, label: "Bayi Toplu Kontor Alır"}],
            numberOfActiveCustomer: 0,
            numberOfPassiveCustomer: 0,
        };
        this.fetchData     = this.fetchData.bind(this);
        this.handleSearch  = this.handleSearch.bind(this);
        this.setPaytrDurumValue = this.setPaytrDurumValue(this);
        this.getCities = this.getCities.bind(this);
        this.getCitiesSelectData = this.getCitiesSelectData.bind(this);
        this.onChangeCity = this.onChangeCity.bind(this);
    }

    componentDidMount() {
        this.getCities();
    }

    async getCities() {
        let self = this;
        let params = {
            url: '/customer/getCities',
            method: "post",
        };
        let result = null;
        await request(params)
            .then(function (response) {
                result = response.data
            }).catch(function (error) {
                showAxiosError(error);
            });
        self.setState({cities: result});
    }

    getCitiesSelectData(){
        let cities= [{value:null, label:"Tümü"}];
        this.state.cities.map(c => (cities.push({value: c.cityName, label: c.cityName})));
        return cities;
    }

    onChangeCity(selectedCity){
        this.setState({selectedCity: selectedCity})
    }

    setPaytrDurumValue(data) {
        for (const dataKey in data) {
            if (dataKey.paytrDurum === 1) {
                dataKey.paytrDurum = "Müşteri Kendi Öder";
            }
            if (dataKey.paytrDurum === 2) {
                dataKey.paytrDurum = "Bayi Müşteri Adına Öder";
            }
            if (dataKey.paytrDurum === 3) {
                dataKey.paytrDurum = "Bayi Toplu Kontor Alır";
            }
        }
        return data;
    }

    fetchData(accessor, direction, page, size) {
        let self = this;
        let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '&sort=createdBy,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: '/customer/fetchByIsDistributor/?page='+ page +'&size='+ size + sortStr + searchQuery ,
            method: "get",
        };
        self.setState({loading: true, searching: true, manual: self.manual === true ? false : self.manual});
        request(params)
            .then(function (response) {
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.customersDistrubutor.totalElements ? response.data.customersDistrubutor.totalElements : '' ,
                    content: response.data.customersDistrubutor.content,
                    loading: false,
                    searching: false,
                    numberOfPassiveCustomer: response.data.customerNum.numberOfPassiveCustomers,
                    numberOfActiveCustomer: response.data.customerNum.numberOfActiveCustomers,
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    render() {

        let flag = this.props.currentUser &&
            (this.props.currentUser.entegrator || this.props.currentUser.distributor) &&
            this.props.currentUser.adminUser;

        const bayiGenelColumns = [
            {
                accessor: [
                    {Header: "VKN/TCKN", accessor: "vknTckn"},
                    {Header: "Ünvan", accessor: "formattedName"}
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.vknTckn}<br/>
                    {<TextOverFlowTooltip text={row.formattedName} maxLength={20}/>}
                </div>)
            },
            {
                accessor: [
                    {Header: "Yetkili", accessor: "yetkili"},
                    {Header: "İl/İlçe", accessor: d => `${d.city} ${d.citySubdivision}`, sortable: false},
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.yetkili}<br/>
                    {row.city + " / " + row.citySubdivision}
                </div>)
            },
            {
                accessor: [
                    {Header: "Telefon 1", accessor: "phoneNum1"},
                    {Header: "Telefon 2", accessor: "phoneNum2"}
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.phoneNum1 ? row.phoneNum1 : "-"}<br/>
                    {row.phoneNum2 ? row.phoneNum2 : "-"}
                </div>)
            },
            {
                accessor: [
                    {Header: "E-Posta Adresi", accessor: "mailAddress"},
                    {Header: "Portal Adresi", accessor: "portalAddress"}
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.mailAddress ? row.mailAddress : "-"}<br/>
                    {row.portalAddress ? row.portalAddress : "-"}
                </div>)
            },
            {
                accessor: [
                    {Header: "Çalışma Şekli", accessor: "workType"},
                    {Header: "Hakediş Oranı", accessor: "hakedisOran"}
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.workType == 1 ? "Müşteri Kendi Öder" : row.workType == 2 ? "Bayi Müşteri Adına Öder" : row.workType == 3 ? "Bayi Toplu Kontor Alır" : "-"}<br/>
                    {row.hakedisOran === 0 || row.hakedisOran  ? "%" + row.hakedisOran : "-"}
                </div>)
            },
            {
                accessor: [
                    {Header: "Aktif Müşteri", accessor: "isActiveNum"},
                    {Header: "Pasif Müşteri", accessor: "isPassiveNum"}
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.isActiveNum  + " Adet"}<br/>
                    {<TextOverFlowTooltip text={row.isPassiveNum  + " Adet"} maxLength={20}/>}
                </div>)
            },
            {
                accessor: [
                    {Header: "Toplam Müşteri", accessor: "totalCustomerNum"},
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.totalCustomerNum  + " Adet"}<br/>
                </div>)
            },
        ];

        const fields = [
            {
                label: "VKN/TCKN",
                accessor: "vknTckn",
                type: "text",
                operator: "="
            },
            {
                label: "Ünvan",
                accessor: "formattedName",
                type: "text",
                operator: "="
            },
            {
                label: "Şehir",
                accessor: "city",
                type: "select",
                operator: "=",
                onOther:this.onChangeCity,
                selectData: this.getCitiesSelectData()
            },
            {
                label: "Çalışma Şekli",
                accessor: "workType",
                type: "select",
                operator: "=",
                selectData: this.state.workType,
            },
        ];

        return (
            <Col sm="12">
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}} id="HakedisDetailedContainer">
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch} hasContainer="HakedisDetailedContainer"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className=" row">
                        <div className="col-sm-12" style={{float: 'right'}}>

                        </div>
                    </div>
                    <div className=" row">
                        <div className="col-sm-12">
                            <Table columns={bayiGenelColumns}
                                   loading={this.state.loading}
                                   loadingText="Kayıtlar getiriliyor..."
                                   content={this.state.content}
                                   total={this.state.total}
                                   page={this.state.page}
                                   manual={this.state.manual}
                                   size={this.state.size}
                                   options={["5", "10", "20", "50", "100"]}
                                   fetchData={this.fetchData}
                                   tableType="BayiList"
                                   numberOfActiveCustomer={this.state.numberOfActiveCustomer}
                                   numberOfPassiveCustomer={this.state.numberOfPassiveCustomer}
                            />
                        </div>
                    </div>
                </div>
            </Col>
        );
    }
}

export default BayiList;
